import React from "react";
import { Text } from "@chakra-ui/react";
export const getIdDisplay = (v) => v.substr(0, 8);
export const IdText = ({ id }) => /* @__PURE__ */ React.createElement(Text, { textStyle: "body-8", as: "span" }, getIdDisplay(id));
